export const COMPACT_LEFT_PX = 250 // category 100 + route 150
export const COMPACT_DAY_PX = 80
export const COMPACT_TABLE_MIN_WIDTH = COMPACT_LEFT_PX + 8 * COMPACT_DAY_PX // 890
